// Exports
export default {
	"Text": "Text_fvF7y",
	"Text_small": "Text_small_HcvCq"
};
